import { HeroIcon } from '@components/HeroIcon'
import { Modal } from '@components/Modal'
import { useIsMobile } from '@hooks/useIsMobile'
import { useTranslation } from 'react-i18next'
import { Dialog, Text, XStack, YStack } from 'tamagui'
import { useBrand } from '@hooks/useBrand'

interface IPaymentRefundErrorModalProps {
  onClose: () => void
  open: boolean
}

export function PaymentRefundErrorModal({
  onClose,
  open,
}: IPaymentRefundErrorModalProps) {
  const { t } = useTranslation('OrderDetails')
  const brand = useBrand()
  const email = brand.paymentsEmail

  const isMobile = useIsMobile()

  const handleOpenEmail = () => {
    window.open(`mailto:${email}`, '_blank')
  }

  return (
    <Modal
      onClose={onClose}
      open={open}
      snapPoints={[60, 100]}
      position={isMobile ? 0 : undefined}
      snapPointsMode={isMobile ? 'constant' : 'percent'}
      backdropOpacity={0.9}
      maxWidth={400}
      dismissOnSnapToBottom={isMobile}
      shouldAdapt={isMobile}
    >
      <YStack
        gap="$size.spacing-xs"
        paddingHorizontal="$size.spacing-xs"
        paddingVertical="$size.spacing-md"
        $gtSm={{
          p: '$size.spacing-lg',
          width: 400,
        }}
        height={isMobile ? 'auto' : '100%'}
        justifyContent="flex-start"
        alignItems="center"
      >
        <YStack gap={16} alignItems="center" width="100%" maxWidth={400}>
          <HeroIcon
            icon={['fal', 'circle-exclamation']}
            color="$danger-100"
            size={48}
          />
          <Dialog.Title
            color="$text-primary"
            ff="$mulishBold"
            fontSize="$font-size-md"
            textAlign="center"
            whiteSpace="pre-line"
            $gtSm={{
              paddingHorizontal: 20,
            }}
          >
            {t('refundError.title')}
          </Dialog.Title>
          <Dialog.Description
            color="$text-secondary"
            fontFamily="$mulishRegular"
            fontSize="$font-size-xxs"
            textAlign="center"
            whiteSpace="pre-line"
            lineHeight={21}
          >
            {t('refundError.description', { brand: brand.name })}
            {'\n'}
            <Text
              color="$accent"
              fontFamily="$mulishRegular"
              fontSize="$font-size-xxs"
              textDecorationLine="underline"
              onPress={handleOpenEmail}
            >
              {email}
            </Text>
            {t('refundError.descriptionPart2')}
          </Dialog.Description>
          <XStack
            justifyContent="center"
            alignItems="center"
            width="100%"
            marginTop="$size.spacing-xs"
          >
            <Text
              color="$accent"
              fontFamily="$mulishRegular"
              fontSize="$font-size-xs"
              textDecorationLine="underline"
              onPress={onClose}
              textAlign="center"
            >
              {t('refundError.closeButton')}
            </Text>
          </XStack>
        </YStack>
      </YStack>
    </Modal>
  )
}
